export default __webpack_public_path__ + "static/media/logotype-on-light-customer.68478460.svg";